import { Box, Divider } from '@hawkins/components';
import { Dimensions } from '@hawkins/variables';
import { Grid } from 'src/domains/shared/components/Grid';
import FramingChart from '../FramingChart';
import FramingChartDownloader from '../FramingChart/FramingChartDownloader';
import { FramingAndWorkingResolutionOutput } from './FramingAndWorkingResolutionOutput';
import { CalculatorOutputProps } from './types';
import { SqueezedMode } from '../../types';

export const CalculatorOutput = (props: CalculatorOutputProps) => {
  const {
    desqueezedFramingChartProps,
    framingAndWorkingResolutionOutput,
    framingChartProps,
    framingIntentLabelError,
    squeezedMode,
  } = props;

  const useDesqueezedFramingChart =
    squeezedMode === SqueezedMode.Desqueezed &&
    desqueezedFramingChartProps;

  const {
    canvasResolution,
    framingDecision,
    framingDecisionCoordinates,
  } = useDesqueezedFramingChart
    ? desqueezedFramingChartProps
    : framingChartProps;

  // If the new calculated props are not provided, we can't render the charts
  // This maintains backward compatibility but requires the Calculator to pass the props
  if (!framingChartProps || !framingAndWorkingResolutionOutput) {
    console.warn(
      'CalculatorOutput: Missing calculated props from service'
    );
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Grid gap={Dimensions.Space16}>
        <FramingChart
          {...(useDesqueezedFramingChart
            ? desqueezedFramingChartProps
            : framingChartProps)}
        />
        <Divider />

        <FramingAndWorkingResolutionOutput
          framingDecision={framingDecision}
          framingDecisionCoordinates={framingDecisionCoordinates}
          framingAndWorkingProps={framingAndWorkingResolutionOutput}
          sensorResolution={canvasResolution}
        />

        <Divider />
        <FramingChartDownloader
          desqueezedFramingChartProps={desqueezedFramingChartProps}
          framingChartProps={framingChartProps}
          framingIntentLabelError={framingIntentLabelError}
        />
      </Grid>
    </Box>
  );
};
